import { Link } from 'react-router-dom';
import { Product } from '../../types';
import { useCart } from '../../context/CartContext';

interface ProductCardProps {
  product: Product;
}

export const ProductCard = ({ product }: ProductCardProps) => {
  const { addToCart, toggleFavorite, favorites } = useCart();
  const isFavorite = favorites.includes(product.id);

  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    addToCart(product);
  };

  const handleToggleFavorite = (e: React.MouseEvent) => {
    e.preventDefault();
    toggleFavorite(product.id);
  };

  const finalPrice = product.discount
    ? product.price * (1 - product.discount / 100)
    : product.price;

  return (
    <Link
      to={`/urun/${product.id}`}
      className="group bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer"
      data-product-shop
    >
      <div className="relative w-full h-64 bg-gray-50 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        {product.isNew && (
          <span className="absolute top-3 left-3 bg-gold-600 text-white text-xs px-3 py-1 rounded-full font-medium whitespace-nowrap">
            Yeni
          </span>
        )}
        {product.discount && (
          <span className="absolute top-3 right-3 bg-red-500 text-white text-xs px-3 py-1 rounded-full font-medium whitespace-nowrap">
            %{product.discount} İndirim
          </span>
        )}
        <button
          onClick={handleToggleFavorite}
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-gold-50 transition-colors whitespace-nowrap"
        >
          <i
            className={`${
              isFavorite ? 'ri-heart-fill text-red-500' : 'ri-heart-line text-gray-600'
            } text-lg`}
          ></i>
        </button>
      </div>

      <div className="p-4">
        <h3 className="font-medium text-gray-800 mb-2 text-sm group-hover:text-gold-600 transition-colors line-clamp-2">
          {product.name}
        </h3>

        <div className="flex items-center gap-3 mb-3 text-xs text-gray-600">
          <span className="flex items-center gap-1">
            <i className="ri-scales-3-line text-gold-600"></i>
            {product.gram}gr
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-vip-crown-line text-gold-600"></i>
            {product.karat} Ayar
          </span>
        </div>

        <div className="flex items-center justify-between mb-3">
          <div>
            {product.discount ? (
              <div className="flex flex-col">
                <span className="text-gray-400 line-through text-xs">
                  {product.price.toLocaleString('tr-TR')} ₺
                </span>
                <span className="text-gold-600 font-semibold text-base">
                  {finalPrice.toLocaleString('tr-TR')} ₺
                </span>
              </div>
            ) : (
              <span className="text-gold-600 font-semibold text-base">
                {product.price.toLocaleString('tr-TR')} ₺
              </span>
            )}
          </div>
          {product.stock < 10 && product.stock > 0 && (
            <span className="text-orange-500 text-xs whitespace-nowrap">
              Son {product.stock} adet
            </span>
          )}
        </div>

        <button
          onClick={handleAddToCart}
          disabled={product.stock === 0}
          className={`w-full py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
            product.stock === 0
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-gold-600 text-white hover:bg-gold-700'
          }`}
        >
          {product.stock === 0 ? 'Stokta Yok' : 'Sepete Ekle'}
        </button>
      </div>
    </Link>
  );
};
